// extracted by mini-css-extract-plugin
export default {"page":"Offers_page__UapfZ","fadeIn":"Offers_fadeIn__3i5cM","header":"Offers_header__3OZ9I","grid":"Offers_grid__7aIjO","actions":"Offers_actions__Mdsfw"};